module.exports = __webpack_public_path__ + "media/images/marquee-4ee0d9b8fade34c5369df765d529cb6f.jpg";